export default __webpack_public_path__ + "static/media/Gauntlets of Courageous Souls.94ac2cdb.jpg";